export default __webpack_public_path__ + "static/media/This took one take, I promise.8d9cc70f.mp4";